export enum ILoadingType {
  "idle",
  "loading",
  "succeeded",
  "failed",
}
